import ContentIndexControls from "@common/components/ContentIndexControls"
import useSortConfig from "@common/hooks/useSortConfig"
import { useStore } from "@state/store"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { Share1Icon, Cross1Icon, HeartIcon } from "@radix-ui/react-icons"
import { useFavoritesStore } from "@state/favouritesStore"
import * as Switch from "@radix-ui/react-switch"
import UnitCompare from "./components/UnitCompare"
import UnitSingle from "./components/UnitSingle"
import Prompt from "./components/Prompt"
import FloorplanSection from "@common/components/ResidenceGeneric/FloorplanSection"
import ViewSection from "@common/components/ViewSection"
import SpecsSection from "@common/components/SpecsSection"
import Modal from "@common/ui/Modal"
import Share from "./components/Share"
import { FlexTable } from "@common/components/table/FlexTable"
import TextButton from "@common/ui/TextButton"
import { useLocation } from "react-router-dom"

const headers = [
  "unitName",
  "price",
  "floor",
  "beds",
  <HeartIcon className="fav-icon" />,
]
const cells = ["unitName", "price", "floor", "beds"]

export default function Favourites(props: any) {
  const { sortConfig, setSortConfig } = useSortConfig()
  const [isShareModalOpen, setIsShareModalOpen] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const syncState = useStore((s) => s.syncState)
  const contentControls = useStore((s) => s.contentControls)
  const stateCategories = ["Floorplan", "View"]
  const { pathname } = useLocation()

  useEffect(() => {
    syncState({
      contentControls: {
        categories: stateCategories,
        index: 0,
      },
    })
    return () => {
      syncState({
        contentControls: null,
        compareMode: true,
        selectedRows: [],
      })
    }
  }, [])

  const { favorites, removeFromFavorites, clearFavorites } = useFavoritesStore(
    (state) => state,
  )

  const { selectedRows } = useStore((state) => state)

  const handleClearFavorites = () => {
    const prompt = document.querySelector(".prompt")
    prompt.classList.toggle("active")
  }

  const sections = [
    { index: 0, component: FloorplanSection },
    { index: 1, component: SpecsSection },
    { index: 2, component: ViewSection },
  ]

  return (
    <>
      <Container className="favourites-container">
        {!favorites || favorites?.length === 0 ? (
          <div className="no-favourites">
            Your Apartment<span>awaits</span>
          </div>
        ) : (
          <>
            <InfoContainer className="favourites-info">
              <UnitCompare
                sections={sections}
                contentControls={contentControls}
                selectedRows={favorites}
                className="unit-compare-container"
              />
            </InfoContainer>
            <Modal
              style={{ backgroundColor: "var(--primary)" }}
              isFullScreen={true}
              isOpen={isShareModalOpen}
              onClose={() => setIsShareModalOpen(false)}
            >
              <Share show={setIsShareModalOpen} config={props} />
            </Modal>
            <div className="tableButton">
              {/* <ContentIndexControls
                className="favourites-control-index"
                categories={stateCategories}
              /> */}
              <div className="favourites-control-index">
                <TextButton
                  onClick={() => handleClearFavorites()}
                  // icon={<Cross1Icon />}
                  iconPosition="right"
                  color="secondary"
                  disabled={favorites.length === 0}
                >
                  Clear Favourites
                </TextButton>

                <TextButton
                  color="secondary"
                  disabled={favorites.length === 0}
                  onClick={() => setIsShareModalOpen(true)}
                  style={{ fontWeight: "bold" }}
                  // icon={<Share1Icon />}
                  iconPosition="right"
                >
                  Share
                </TextButton>
              </div>
              <div className="clear-favorites prompt">
                <Prompt
                  onConfirm={() => {
                    clearFavorites()
                    syncState({ selectedRows: [] })
                    document.querySelector(".prompt").classList.toggle("active")
                  }}
                />
              </div>
            </div>
          </>
        )}
      </Container>
    </>
  )
}

const Container = styled.div`
  .tableButton {
    position: fixed;
    left: 0;
    bottom: 2rem;
    left: 4rem;
    width: calc(15% - 6rem);
    color: white;
    cursor: pointer;
    pointer-events: all;
    z-index: 20000;
    display: flex;
    flex-wrap: wrap;
    height: 8rem;
    gap: 1%;
    overflow: hidden;

    .favourites-control-index {
      display: flex;
      height: 4rem;
      width: 100%;
      gap: 1%;

      & div {
        width: 50% !important;
        background-color: var(--secondary);
        border-radius: 5px;
        border: 1px solid white;
      }
    }

    .clear-favorites {
      width: 100%;
      position: absolute;
      bottom: 0;
      z-index: 1;
      transform: translateX(-100%);
      transition: transform 0.3s ease-in-out;

      & div {
        width: 100% !important;
        /* background-color: var(--secondary); */
        border-radius: 5px;
      }
    }
    .prompt {
      height: 49%;
      display: flex;
      gap: 1% !important;
    }
    .active {
      transform: translateX(0%);
    }
  }
`

const InfoContainer = styled.div``

const TableContainer = styled.div``

const BottomControls = styled.div``
